import React, { useEffect, useState, useRef, useCallback } from "react";
import { json, useNavigate } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { format, parseISO } from "date-fns";
import "./SearchCompany.css";
import { Typeahead, Highlighter } from "react-bootstrap-typeahead";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { debounce } from 'lodash'
import {
  setLandingTabs,
  setSelectedCompany,
  setSelectedIndustry,
  setSelectedHouse,
  SetErrorStatus,
  setExport,
  setPeersetData,
  setcompanyCoCode,
} from "../../Redux/Slices/CommonLocalRedux/CommonSliceStorage";
import { setLeftHeadMenu, SetLeftMenuTap, setPageName, SetTopMenuNavigation, Set_TOP_NAVIGATION, Set_LEFT_MENU_NAVIGATION, Set_SUB_LEFT_MENU_NAVIGATION } from "../../Redux/Slices/CommonLocalRedux/NavigationSlice";
import { CommonBaseURl, ScreenerUrl } from "../../Commonprovider/CommonProvider";
import { setIsConsolidate } from "../../Redux/Slices/CommonLocalRedux/CommonSliceStorage";
import { setPeersetName, setPeersetType } from "../../Redux/Slices/ScreenerRedux/CommonReduxSlices/ScreenerCommonSlice";
import ReportAnalysis from "../../../src/Images/statisctics.png"
import { UserListedValue } from "../../CommonFunction/Functions";
export const SearchCompany = ({ LandingTabs, width }) => {
  const navigate = useNavigate();
  const Listed_Only = UserListedValue()
  const [Companies, setCompanies] = useState([]);
  const dispatch = useDispatch();
  const [BaseURL] = useState(CommonBaseURl);
  const Token = useSelector((state) => state.Authenticationapi.token);
  const TopNavigateTap = useSelector((state) => state.Navigation.Topnavigate);
  const ErrorStatus = useSelector((state) => state.LocalValuesData.ErrorStatus);
  const exported = useSelector(state => state.LocalValuesData.exported)
  const LeftNode = useSelector((state) => state.Navigation.LeftHeadMenu);
  const UserDetails = useSelector((state) => state.LoginUserDetails.data);
  const Section = useSelector((state) => state.Navigation.Topnavigate[1]);
  const activelandingtab = useSelector(
    (state) => state.LocalValuesData.LandingTabs
  );
  const Subtype = useSelector((state) => state.LocalValuesData.subType)
  const GetReportAnalysis = useSelector((state) => state.LocalValuesData.GetReportAnalysis)

  const Landingpage = useSelector(state => state.Navigation.landingpage)
  const SelectedIndustry = useSelector(
    (state) => state.LocalValuesData.SelectedIndustry
  );
  const SelectedHouse = useSelector(
    (state) => state.LocalValuesData.SelectedHouse
  );
  const SelectedLeftTab = useSelector(
    (state) => state.Navigation.LeftMenuNavigate
  );
  const LeftHeadMenu = useSelector((state) => state.Navigation.LeftHeadMenu);
  const TOP_NAVIGATION = useSelector(
    (state) => state.Navigation.TOP_NAVIGATION
  );
  const LEFT_MENU_NAVIGATION = useSelector(
    (state) => state.Navigation.LEFT_MENU_NAVIGATION
  );
  const SUB_LEFT_MENU_NAVIGATION = useSelector(
    (state) => state.Navigation.SUB_LEFT_MENU_NAVIGATION
  );
  const IsConsolidate = useSelector(
    (state) => state.LocalValuesData.IsConsolidate
  );
  const Export = useSelector((state) => state.LocalValuesData.Export);
  const Innerpage = useSelector((state) => state.LocalValuesData.Innerpage);
  const PageName = useSelector((state) => state.Navigation.PageName);
  const SelectedPeerset = useSelector(
    (state) => state.Screenercommon.PeersetName
  );
  const [latestData, setLatestData] = useState([]);
  const [subCompDrop, setSubCompDrop] = useState([]);
  const [showSubCompDiv, setShowSubCompDiv] = useState(false);
  const subsidiaryCompany = useSelector((state) => state.LocalValuesData.companyCoCode?.[0]?.Co_Code || "");
  const [myValue, setMyValue] = useState("");
  const SelectedCompany = useSelector((state) => state.LocalValuesData.SelectedCompany);
  //rdeux
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [getPeerSet, setGetPeerSet] = useState('My');
  const [Peerset, setPeerset] = useState([]);
  const [peerSetValue, setpeerSetValue] = useState(localStorage.getItem("peersetName") || "select");
  const [selectedItem, setSelectedItem] = useState("Subsidiary Company")
  const [opendropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const avgActiveTab = useSelector(state => state.Navigation.avgActiveTab)
  const [showDataTooltip, setShowDataTooltip] = useState(true);
  const [DWlimit, setDWlimit] = useState([]);
  const [imgError, setImgError] = useState(false);
  const handleSubmitLive = async () => {

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://reportanalysis.capitaline.com/Login.aspx";
    form.target = "_blank";
    // form.id = `form${formValue}`
    const userInput = document.createElement("input");
    userInput.type = "hidden";
    userInput.name = "username";
    userInput.value = "admin";  // or use setLiveU state variable if available
    form.appendChild(userInput);

    // Create Pwd input
    const pwdInput = document.createElement("input");
    pwdInput.type = "hidden";
    pwdInput.name = "passwrd";
    pwdInput.value = "Cline@analysis";
    form.appendChild(pwdInput);


    const optInput = document.createElement("input");
    optInput.type = "hidden";
    optInput.name = 'cocode';
    optInput.value = SelectedCompany[0]?.Co_Code || SelectedCompany[0]?.co_code;
    form.appendChild(optInput);


    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (opendropdown === 3) {
          setOpenDropdown(null); // or set to false, depending on your logic
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [opendropdown]);

  const Showpeersetdata = () => {
    const params = {
      test: "Abc",
      action: "get",
      formulaId: 0,
      name: "",
      formula: "",
      folder: "",
      comments: "",
      type: getPeerSet,
      info: "",
      userid: "",
      Opt: "MY",
      test2: "Abc",
    };
    // dispatch(setSelectedUserPeersetData(PeerSetName));
    let spname = getPeerSet === "CM" ? "ManageCMPeerSet" : 'ManagePeerSet'
    fetch(`${ScreenerUrl}${spname}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${Token.access_token}`,
      },
      body: new URLSearchParams(params).toString(),
    })
      .then((response) => response.json())
      .then((json) => {
        const data = JSON.parse(json);
        // Store in Redux
        setPeerset(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        alert('Failed to save PeerSet');
      });
  };


  const handleDropdownChange = (e) => {
    setpeerSetValue(e.target.value);
    dispatch(setPeersetName(e.target.value));
    if (SelectedLeftTab === 'PeersetFact Sheet') {
      navigate(`/Peerset/Peerset/PeersetFactSheet`)
    }
  };

  const handleItemClick = (name, code) => {
    setSelectedItem(name);
    setMyValue(code);
  };

  const handleCustomDropdownClick = (index) => {
    setOpenDropdown((prev) => (prev === index ? null : index));
  };

  const RedirectToCompany = (Co_code) => {
    if (Token != null) {
      fetch(`${BaseURL}GetCompIndName?co_code=${Co_code}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: "Bearer " + Token.access_token,
        }
      })
        .then((response) => response.json())
        .then((json) => {
          // debugger
          let data = JSON.parse(json);
          dispatch(SetErrorStatus(false));
          dispatch(SetTopMenuNavigation([2, "Company"]));
          dispatch(setSelectedCompany(data));
          dispatch(setSelectedHouse(data));
          dispatch(setSelectedIndustry(data));
          dispatch(setcompanyCoCode(data));
          dispatch(setLeftHeadMenu('General'));
          dispatch(SetLeftMenuTap('Background'));
          dispatch(setPageName('Background'));
          dispatch(Set_TOP_NAVIGATION('Company'));
          dispatch(Set_LEFT_MENU_NAVIGATION('General'));
          dispatch(Set_SUB_LEFT_MENU_NAVIGATION('Background'));
          navigate('/Company/General/Background');
        });
    }
  }

  // const GetSearchCompanies = debounce(async(searchText) => {

  //   // debugger;
  //   if (!searchText) {
  //     console.log("No search text provided");
  //     setCompanies([]);
  //     return;
  //   }
  //   var FunctionName;
  //   if (TopNavigateTap[1] == "Company" || "Home") {
  //     FunctionName = "GetCompanySearch";
  //   }
  //   if (TopNavigateTap[1] == "Industry") {
  //     FunctionName = "GetIndustryList";
  //   }
  //   if (TopNavigateTap[1] == "House") {
  //     FunctionName = "GetHouseList";
  //   }
  //  // await new Promise((resolve) => setTimeout(resolve, 1000));
  //   if (Token != null) {
  //     fetch(`${BaseURL}${FunctionName}?text=${searchText}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-type": "application/json; charset=UTF-8",
  //         Authorization: "Bearer " + Token.access_token,
  //       },
  //     })
  //       .then((Response) => Response.json())
  //       .then((data) => {
  //         let fetchedCompanies = JSON.parse(data);
  //         setCompanies(fetchedCompanies);
  //       });
  //   }
  // },500);

  // update code of GetSearchCompanies start here ......
  const GetSearchCompanies = useCallback(
    debounce(async (searchText) => {
      try {
        if (!searchText) {
          setCompanies([]);
          return;
        }

        let FunctionName;
        if (TopNavigateTap[1] === "Company" || TopNavigateTap[1] === "Home") {
          FunctionName = "GetCompanySearch";
        } else if (TopNavigateTap[1] === "Industry") {
          FunctionName = "GetIndustryList";
        } else if (TopNavigateTap[1] === "House") {
          FunctionName = "GetHouseList";
        } else {
          setCompanies([]);
          return;
        }

        if (!Token?.access_token) {
          console.error("Invalid or missing access token");
          setCompanies([]);
          return;
        }
        let url

        if (FunctionName == "GetCompanySearch") {
          // url = `${BaseURL}${FunctionName}?text=${searchText}`;
          // url = `${BaseURL}${FunctionName}?text=${searchText}`;
          url = `${BaseURL}${FunctionName}?text=${searchText}&ListedOnly=${Listed_Only}`;
        } else {
          url = `${BaseURL}${FunctionName}?text=${searchText}`;
        }
        const response = await fetch(`${url}`, {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${Token.access_token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setCompanies(JSON.parse(data));
      } catch (error) {
        console.error("Error fetching companies:", error);
        setCompanies([]);
      }
    }, 700),
    [Token, BaseURL, TopNavigateTap]
  );


  // update code o1f GetSearchCompannies end here.....



  const selectedCompanyFunc = (selecteddata) => {

    try {
      if (selecteddata != undefined && selecteddata.length > 0) {
        if (TopNavigateTap[1] == "Company" || TopNavigateTap[1] == "Home") {
          fetch(`${BaseURL}GetCompIndName?co_code=${selecteddata[0].CO_CODE}`, {
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: "Bearer " + Token.access_token,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              try {
                if (!SelectedLeftTab) {
                  dispatch(SetErrorStatus(false));
                  dispatch(SetTopMenuNavigation([2, "Company"]));
                  dispatch(setSelectedCompany(JSON.parse(data)));
                  dispatch(setcompanyCoCode(JSON.parse(data)));
                  dispatch(setSelectedHouse(JSON.parse(data)));
                  dispatch(setSelectedIndustry(JSON.parse(data)));
                  dispatch(setLeftHeadMenu('General'));
                  dispatch(SetLeftMenuTap('Background'));
                  dispatch(setPageName('Background'));
                  dispatch(Set_TOP_NAVIGATION('Company'));
                  dispatch(Set_LEFT_MENU_NAVIGATION('General'));
                  dispatch(Set_SUB_LEFT_MENU_NAVIGATION('Background'));
                  setTimeout(() => {
                    navigate("/Company/General/Background");
                  }, 100);
                } else {
                  dispatch(SetErrorStatus(false));
                  dispatch(SetTopMenuNavigation([2, "Company"]));
                  dispatch(setSelectedCompany(JSON.parse(data)));
                  dispatch(setcompanyCoCode(JSON.parse(data)));
                  dispatch(setSelectedHouse(JSON.parse(data)));
                  dispatch(setSelectedIndustry(JSON.parse(data)));
                  setTimeout(() => {
                    navigate(
                      `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
                    );
                    // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
                  }, 100);
                }
                setSearchText(""); // Clear the search text
                setSelected([]);
              } catch (error) {
                console.log("issue while fetch serch company", error);
              }
            });
        }
        if (TopNavigateTap[1] == "Industry") {
          if (!SelectedLeftTab) {
            dispatch(setSelectedIndustry(selecteddata));
            // window.location.href = `/${TopNavigateTap[1]}/General/IndustryFactSheet`;
            navigate(`/${TopNavigateTap[1]}/General/IndustryFactSheet`);
          } else {
            dispatch(setSelectedIndustry(selecteddata));
            // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
            navigate(
              `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
            );
          }
          setSearchText("");
          setSelected([]);
        }
        if (TopNavigateTap[1] == "House") {
          if (!SelectedLeftTab) {
            dispatch(setSelectedHouse(selecteddata));
            navigate(`/${TopNavigateTap[1]}/General/HouseFactSheet`);
            // window.location.href = `/${TopNavigateTap[1]}/General/HouseFactSheet`;
          } else {
            dispatch(setSelectedHouse(selecteddata));
            // window.location.href = `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
            navigate(
              `/${TOP_NAVIGATION}/${LEFT_MENU_NAVIGATION}/${SUB_LEFT_MENU_NAVIGATION}`
            );
          }
          setSearchText("");
          setSelected([]);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  function formatDate(dateString) {
    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      "en-GB",
      options
    );
    return formattedDate;
  }

  // useEffect(() => {
  //     if (Token != null) {

  //         try {
  //             fetch(`${BaseURL}GetPeersetList?Name=`, {
  //                 method: 'GET',
  //                 headers: {
  //                     'Content-type': 'application/json; charset=UTF-8',
  //                     'Authorization': 'Bearer ' + Token.access_token,
  //                 }
  //             }).then((Response) => Response.json())
  //                 .then((json) => {
  //                     let data = JSON?.parse(json)

  //                     setPeerset(data)
  //                 })
  //         } catch (error) {

  //             console.log("errorerrorerror", error);

  //         }

  //     }

  //     if (Token != null) {
  //         fetch(`${BaseURL}/GetLatestPrice?co_code=20558&exch=BSE`, {
  //             method: 'GET',
  //             headers: {
  //                 'Content-type': 'application/json; charset=UTF-8',
  //                 'Authorization': 'Bearer ' + Token.access_token,
  //             },
  //         }).then((response) => response.json())
  //             .then((data) => {
  //                 let date = JSON?.parse(data);
  //                 setLatestData(date[0]);
  //             })
  //     }

  // }, [])

  useEffect(() => {
    const fetchData = async () => {
      if (Token != null) {
        try {
          // Fetch Peerset List
          const peersetResponse = await fetch(
            `${BaseURL}GetPeersetList?Name=`,
            {
              method: "GET",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: "Bearer " + Token.access_token,
              },
            }
          );
          const peersetJson = await peersetResponse.json();
          const peersetData = JSON?.parse(peersetJson);
          dispatch(setPeersetData(peersetData))
          setPeerset(peersetData);
          // Fetch Latest Price
          const latestPriceResponse = await fetch(
            `${BaseURL}/GetLatestPrice?co_code=20558&exch=BSE`,
            {
              method: "GET",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: "Bearer " + Token.access_token,
              },
            }
          );
          const latestPriceJson = await latestPriceResponse.json();
          const latestPriceData = JSON?.parse(latestPriceJson);
          setLatestData(latestPriceData[0]);
        } catch (error) {
          console.log("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [Token]);

  useEffect(() => {
    const fetchSubCompanies = () => {
      if (subsidiaryCompany) {
        try {
          fetch(`${BaseURL}Getsubcomp?co_code=${subsidiaryCompany}`, {
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: "Bearer " + Token.access_token,
            },
          })
            .then((response) => response.json())
            .then((json) => {
              let data1 = JSON.parse(json);

              setSubCompDrop(data1);
              setShowSubCompDiv(true);
            });
        } catch (error) {
          alert(error?.message || "An error occurred while fetching data.");
        }
      }
    };

    fetchSubCompanies();
  }, [subsidiaryCompany]);

  useEffect(() => {
    if (myValue) {
      subCompCall();
    }
  }, [myValue]);


  useEffect(() => {
    Showpeersetdata();
  }, [BaseURL, peerSetValue, getPeerSet]);

  const subCompCall = async () => {
    try {
      if (!myValue) return;
      const response = await fetch(`${BaseURL}GetCompIndName?co_code=${myValue}`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + Token.access_token,
        },
      });

      const json = await response.json();

      if (response.ok) {
        const SelCompany = JSON.parse(json);
        if (SelCompany.length > 0) {
          dispatch(setSelectedCompany(SelCompany));
          if (SelCompany[0].Industry_Code) {
            dispatch(setSelectedIndustry(SelCompany));
          }
          if (SelCompany[0].House_Code) {
            dispatch(setSelectedHouse(SelCompany));
          }


          // setTimeout(() => {
          //   navigate("/Companyinfo");
          //   dispatch(setLeftHeadMenu(""))
          //   dispatch(SetLeftMenuTap(""))
          //   dispatch(setPageName(""))
          //   dispatch(LEFT_MENU_NAVIGATION(""))
          // }, 300);


        }
      } else {
        alert("Failed to fetch company data.");
      }
    } catch (error) {
      alert(error?.message || "An error occurred while fetching data.");
    }
  };


  const [scrolled, setScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY && currentScrollY > 50) {
      setScrolled(true);
    }
    else if (currentScrollY > lastScrollY && currentScrollY > 50) {
      setScrolled(false);
    }

    if (currentScrollY === 0) {
      setScrolled(false);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);


  const getPlaceholder = () => {
    switch (TopNavigateTap[1]) {
      case "Company":
      case "Home":
        return "Enter Company Name";
      case "Industry":
        return "Enter Industry Name";
      case "House":
        return "Enter House Name";
      default:
        return "Enter Company Name";
    }
  };

  const showTypeahead = ["Company", "Home", "Industry", "House", 'Ipo', 'CS'].includes(TopNavigateTap[1]);

  const bytesToMB = (bytes) => {
    if (!bytes) return "0 MB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  // function formatKB(kb) {
  //   const KB_IN_MB = 1024;
  //   const KB_IN_GB = 1024 * 1024;

  //   const gb = Math.floor(kb / KB_IN_GB);
  //   const mb = Math.floor((kb % KB_IN_GB) / KB_IN_MB);
  //   const remKB = Math.floor(kb % KB_IN_MB);

  //   let result = [];

  //   if (gb > 0) result.push(`${gb} GBs`);
  //   if (mb > 0) result.push(`${mb} MBs`);
  //   if (gb === 0 && remKB > 0) result.push(`${remKB} KBs`);

  //   return result.join(" ");
  // }

  function formatKB(kb) {
    const KB_IN_MB = 1024;
    const KB_IN_GB = 1024 * 1024;

    if (kb >= KB_IN_GB) {
      const gb = Math.round(kb / KB_IN_GB);
      return `${gb} GB`;
    }

    const mb = Math.round(kb / KB_IN_MB);
    return `${mb} MB`;
  }

  function formatUsageTooltip(usedKB, remainingKB, limitKB) {
    return `Used: ${formatKB(usedKB)}; Remaining: ${formatKB(remainingKB)}; Limit: ${formatKB(limitKB)}`;
  }

  useEffect(() => {
    fetch(`${BaseURL}GetDownloadSize?UserID=${UserDetails[0].ParentUserid || JSON.parse(UserDetails)[0].ParentUserid}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: "Bearer " + Token.access_token,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        let data1 = JSON.parse(json);
        setDWlimit(data1)
      });
    const timer = setTimeout(() => setShowDataTooltip(false), 5000);
    return () => clearTimeout(timer);
  }, [exported]);

  return (
    <>
      {TopNavigateTap[1] == "Home" && Landingpage && (
        <div className={`main-search-box ${scrolled ? "scrolled-class" : ""}`}>
          {/* style={{ width: `calc(100vw - ${width}px - ${30}px)` }} */}
          {TopNavigateTap[1] == "Home" && (
            <div>
              <ul className="common-tabs landing-tabs">
                <li>
                  <a
                    className={
                      activelandingtab == "MarketPerformance" ? "active" : ""
                    }
                    onClick={() =>
                      dispatch(setLandingTabs("MarketPerformance"))
                    }
                  >
                    Market Performance
                  </a>
                </li>

                <li>
                  <a
                    className={
                      activelandingtab == "StockScreener" ? "active" : ""
                    }
                    onClick={() => dispatch(setLandingTabs("StockScreener"))}
                  >
                    Stock Screener
                  </a>
                </li>
                {/* <li>
                  <a
                    className={
                      activelandingtab == "CMScreener" ? "active" : ""
                    }
                    onClick={() => dispatch(setLandingTabs("CMScreener"))}
                  >
                    CM Screener
                  </a>
                </li> */}

                {/* <li>
                  <a
                    className={
                      activelandingtab == "TrendingScreener" ? "active" : ""
                    }
                    onClick={() => dispatch(setLandingTabs("TrendingScreener"))}
                  >
                    Trending CM Screener
                  </a>
                </li> */}

                <div className="data-usage-item">
                  {/* <p
                      onMouseEnter={() => setShowDataTooltip(true)}
                      onMouseLeave={() => setShowDataTooltip(false)}
                    >
                      <span className="info-icon">i</span>
                    </p> */}


                  {/* <li>
                  <a
                    // className={
                    //   activelandingtab == "MyScreener" ? "active" : ""
                    // }
                    onClick={() =>navigateToMyScreener()}
                  >
                    My Screener
                  </a>
                </li> */}


                  {DWlimit?.[0]?.DWLimit > 0 && showDataTooltip && (
                    <div className="data-usage-tooltip">
                      <div className="tooltip-title">
                        <span className="info-icon small">i</span>
                        <strong>Data Usage</strong>
                      </div>
                      <div className="tooltip-content">
                        {/* Used: <b>{formatBytesToMBKB(DWlimit[0]?.TotalExportSize)}</b>, Remaining: <b>{formatBytesToMBKB(DWlimit[0]?.Remaining)}</b>, Limit: <b>{formatBytesToMBKB(DWlimit[0]?.DWLimit)}</b> */}
                        <p> Used: {formatKB(DWlimit[0]?.TotalExportSize)}</p>
                        <p> Remaining: {formatKB(DWlimit[0]?.Remaining)}</p>
                        <p> Limit: {formatKB(DWlimit[0]?.DWLimit)}</p>
                      </div>
                    </div>
                  )}
                </div>

              </ul>
            </div>
          )}
          <div className="searchbar">
            <Typeahead
              className={ErrorStatus ? "error" : ""}
              id="companySearch"
              labelKey={(option) => `${option.Name || option.CO_NAME || option.CO_CODE}`}
              minLength={2}
              options={Companies}
              style={{ color: "red" }}
              placeholder="Enter Company Name"
              onChange={selectedCompanyFunc}
              onInputChange={(query) => {
                setSearchText(query);
                GetSearchCompanies(query);
              }}
              filterBy={() => true}
              selected={selected}
              inputValue={searchText}
              renderMenuItemChildren={(option, props) => {
                const label = `${option.Name || option.CO_NAME || option.CO_CODE}`;
                const query = props.text; // This is the current input

                const regex = new RegExp(`(${query})`, 'gi');
                const parts = label.split(regex);

                return (
                  <div>
                    {parts.map((part, index) =>
                      regex.test(part) ? (
                        <strong key={index}>{part}</strong> // Bold match
                      ) : (
                        <span key={index}>{part}</span> // Normal text
                      )
                    )}
                  </div>
                );
              }}
            />
            {Subtype !== 0 && Subtype !== null && activelandingtab === 'MarketPerformance' && (
              <div className="leftmargin">
                <span title="Export to Excel" onClick={() => dispatch(setExport('true'))}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.79231 7.6752L4.25781 6.7002V13.9047C4.25775 13.983 4.27314 14.0605 4.3031 14.1329C4.33307 14.2052 4.37702 14.271 4.43244 14.3263C4.48785 14.3816 4.55365 14.4254 4.62604 14.4553C4.69843 14.4851 4.77601 14.5004 4.85431 14.5002H14.4043C14.4827 14.5005 14.5604 14.4854 14.6329 14.4556C14.7054 14.4258 14.7713 14.382 14.8268 14.3266C14.8824 14.2713 14.9264 14.2055 14.9564 14.1331C14.9865 14.0607 15.0019 13.9831 15.0018 13.9047V11.2502L9.79231 7.6752Z" fill="#185C37" />
                    <path d="M9.79231 1.5H4.85431C4.77601 1.4998 4.69843 1.51507 4.62604 1.54491C4.55365 1.57475 4.48785 1.6186 4.43244 1.67392C4.37702 1.72924 4.33307 1.79496 4.3031 1.8673C4.27314 1.93965 4.25775 2.0172 4.25781 2.0955V4.75L9.79231 8L12.7228 8.975L15.0018 8V4.75L9.79231 1.5Z" fill="#21A366" />
                    <path d="M4.25781 4.75H9.79231V8H4.25781V4.75Z" fill="#107C41" />
                    <path opacity="0.1" d="M8.21881 4.09961H4.25781V12.2246H8.21881C8.37665 12.2238 8.52781 12.1609 8.63956 12.0494C8.75131 11.9379 8.81463 11.7869 8.81581 11.6291V4.69511C8.81463 4.53728 8.75131 4.38627 8.63956 4.2748C8.52781 4.16334 8.37665 4.10039 8.21881 4.09961Z" fill="black" />
                    <path opacity="0.2" d="M7.89331 4.4248H4.25781V12.5498H7.89331C8.05115 12.549 8.20231 12.4861 8.31406 12.3746C8.42581 12.2631 8.48913 12.1121 8.49031 11.9543V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                    <path opacity="0.2" d="M7.89331 4.4248H4.25781V11.8998H7.89331C8.05115 11.899 8.20231 11.8361 8.31406 11.7246C8.42581 11.6131 8.48913 11.4621 8.49031 11.3043V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                    <path opacity="0.2" d="M7.56781 4.4248H4.25781V11.8998H7.56781C7.72565 11.899 7.87681 11.8361 7.98856 11.7246C8.10031 11.6131 8.16363 11.4621 8.16481 11.3043V5.0203C8.16363 4.86247 8.10031 4.71147 7.98856 4.6C7.87681 4.48853 7.72565 4.42559 7.56781 4.4248Z" fill="black" />
                    <path d="M1.597 4.42481H7.566C7.72411 4.42468 7.87581 4.48732 7.98776 4.59899C8.0997 4.71065 8.16273 4.86219 8.163 5.02031V10.9793C8.16273 11.1374 8.0997 11.289 7.98776 11.4006C7.87581 11.5123 7.72411 11.5749 7.566 11.5748H1.597C1.51865 11.5751 1.44103 11.5599 1.36857 11.53C1.29612 11.5002 1.23027 11.4564 1.1748 11.4011C1.11933 11.3457 1.07534 11.28 1.04534 11.2076C1.01534 11.1352 0.999934 11.0577 1 10.9793V5.02031C0.999934 4.94196 1.01534 4.86437 1.04534 4.79199C1.07534 4.71962 1.11933 4.65388 1.1748 4.59855C1.23027 4.54322 1.29612 4.49939 1.36857 4.46957C1.44103 4.43976 1.51865 4.42454 1.597 4.42481Z" fill="url(#paint0_linear_3764_5518)" />
                    <path d="M2.85156 9.93648L4.10706 7.99448L2.95706 6.06348H3.88056L4.50806 7.29998C4.56606 7.41698 4.60806 7.50398 4.62706 7.56198H4.63556C4.67656 7.46831 4.7199 7.37731 4.76556 7.28898L5.43656 6.06548H6.28656L5.10706 7.98548L6.31656 9.93798H5.41206L4.68706 8.58248C4.6535 8.52415 4.62489 8.4631 4.60156 8.39998H4.58956C4.56837 8.4615 4.54019 8.52038 4.50556 8.57548L3.75906 9.93648H2.85156Z" fill="white" />
                    <path d="M14.4016 1.5H9.78906V4.75H14.9986V2.0955C14.9986 2.01716 14.9832 1.93957 14.9532 1.86719C14.9232 1.79481 14.8792 1.72907 14.8238 1.67374C14.7683 1.61841 14.7024 1.57458 14.63 1.54477C14.5575 1.51495 14.4799 1.49974 14.4016 1.5Z" fill="#33C481" />
                    <path d="M9.78906 8H14.9986V11.25H9.78906V8Z" fill="#107C41" />
                    <defs>
                      <linearGradient id="paint0_linear_3764_5518" x1="2.247" y1="3.95681" x2="6.916" y2="12.0428" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#18884F" />
                        <stop offset="0.5" stop-color="#117E43" />
                        <stop offset="1" stop-color="#0B6631" />
                      </linearGradient>
                    </defs>
                  </svg>

                </span>
              </div>

            )}
          </div>
          {/* {TopNavigateTap[1] != "Home" && (
                        <>
                            {(TopNavigateTap[1] == 'Company' && SelectedCompany != "") && (
                                <a>{SelectedCompany[0]?.CO_NAME}</a>
                            )}
                            {(TopNavigateTap[1] == 'Industry' && SelectedIndustry != "") && (
                                <a>{SelectedIndustry[0].Ind_L_Name || SelectedIndustry[0].Name}</a>
                            )}
                            {(TopNavigateTap[1] == 'House' && SelectedHouse != "") && (
                                <a>{SelectedHouse[0].House_Name || SelectedHouse[0].Name}</a>
                            )}
                        </>
                    )} */}
        </div>
      )}


      {((TopNavigateTap[1] != "Home" || !Landingpage) && TopNavigateTap[1] != "Peerset") && (
        <div className={`main-company-box ${scrolled ? "scrolled-class" : ""}`} >
          {/* style={{ width: width == 'fit-content' ? width : `calc(100vw - ${width}px - ${30}px)` }} */}
          <div className="d-flex">
            {/* {SelectedCompany[0]?.FileName && (
              <img src={`https://www.capitalmarket.com/IImagesnew/${SelectedCompany[0]?.FileName}`} height={70} width={70} />
            )} */}
            <div className='left'>
              <div className='top'>
                <div className='company-detail'>
                  {SelectedCompany[0]?.FileName && (
                    <img
                      src={`https://www.capitalmarket.com/IImagesnew/${SelectedCompany[0]?.FileName}`}
                      height={35}
                      width={35}
                      style={{ marginRight: '5px', display: imgError ? 'none' : 'block' }}
                      onError={() => setImgError(true)}
                      onLoad={() => setImgError(false)} // 

                    />
                  )}
                  {((TopNavigateTap[1] == 'Company' || TopNavigateTap[1] == 'CS' || TOP_NAVIGATION === 'company') && SelectedCompany != "") && (
                    <>
                      <p onClick={() => RedirectToCompany(SelectedCompany[0]?.Co_Code || SelectedCompany[0]?.co_code)}>{SelectedCompany[0]?.CO_NAME || SelectedCompany[0]?.Co_Name}</p>
                      <p className='blackcolor'>CMP {SelectedCompany?.[0]?.ClosePrice}</p>
                      <p className={SelectedCompany[0]?.Change < 0 ? 'redcolor' : 'greencolor'}>
                        {SelectedCompany[0] ? (SelectedCompany[0]?.Change)?.toFixed(2) : null}
                        {/* {{SelectedCompany[0] ? (SelectedCompany[0]?.PChange)?  {SelectedCompany[0] ? (SelectedCompany[0]?.PChange)?.toFixed(2)'%'  : ''}  */}
                        {SelectedCompany[0]?.PChange ? `  (${(SelectedCompany[0]?.PChange)?.toFixed(2)}%) ` : null}
                      </p>
                    </>
                  )}
                  {(TopNavigateTap[1] == 'Industry' && SelectedIndustry != "") && (
                    <>
                      <p>{TopNavigateTap[1]} : {SelectedIndustry[0]?.Ind_L_Name || SelectedIndustry[0]?.Name}</p>
                      <p></p>
                    </>
                  )}
                  {(TopNavigateTap[1] == 'House' && SelectedHouse != "") && (
                    <>
                      <p> {TopNavigateTap[1]} : {SelectedHouse[0]?.House_Name || SelectedHouse[0]?.Name}</p>
                      <p></p>
                    </>
                  )}
                </div>
                <div className='dates'>
                  {/* <span>(As on {formatDate(latestData["Date"])})</span> */}


                  {(Section === 'Company' && subCompDrop && subCompDrop.length > 0) && (
                    <div className='' ref={dropdownRef} id="subcompdiv">
                      <div className='common-select custom-dropdown' onClick={() => handleCustomDropdownClick(3)}>
                        <button className='custom-dropbtn'>
                          {selectedItem || 'Select Company'}
                        </button>
                        {opendropdown === 3 && (
                          <div className='dropdown-list common-scroller'>
                            <ul className='no_style common-tabs-mobile secondary'>
                              {subCompDrop.map((comp, index) => (
                                <li key={index}>
                                  <Link
                                    className={`${selectedItem === comp.CO_NAME ? 'active' : ''}`}
                                    onClick={() => handleItemClick(comp.CO_NAME, comp.CO_CODE)}
                                  >
                                    {comp.CO_NAME}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                      </div>
                    </div>
                  )}


                  {Subtype !== 0 && Subtype !== null && (LeftHeadMenu === 'Reports') && (
                    <div className='ms-2'>
                      <span title="Export to Word" onClick={() => dispatch(setExport('Exportword'))} >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.4048 1.5H4.85431C4.77601 1.49981 4.69843 1.51507 4.62604 1.54491C4.55365 1.57476 4.48785 1.6186 4.43244 1.67392C4.37702 1.72924 4.33307 1.79496 4.3031 1.86731C4.27314 1.93965 4.25775 2.0172 4.25781 2.0955V4.75L9.79231 6.375L15.0018 4.75V2.0955C15.0019 2.01716 14.9865 1.93957 14.9565 1.86719C14.9265 1.79481 14.8825 1.72907 14.827 1.67374C14.7715 1.61841 14.7057 1.57458 14.6332 1.54477C14.5608 1.51495 14.4832 1.49974 14.4048 1.5Z" fill="#41A5EE" />
                          <path d="M15.0018 4.75H4.25781V8L9.79231 8.975L15.0018 8V4.75Z" fill="#2B7CD3" />
                          <path d="M4.25781 8V11.25L9.46681 11.9L15.0018 11.25V8H4.25781Z" fill="#185ABD" />
                          <path d="M4.85431 14.5H14.4043C14.4827 14.5003 14.5604 14.4852 14.6329 14.4554C14.7054 14.4256 14.7713 14.3818 14.8268 14.3264C14.8824 14.2711 14.9264 14.2053 14.9564 14.1329C14.9865 14.0605 15.0019 13.9829 15.0018 13.9045V11.25H4.25781V13.9045C4.25775 13.9828 4.27314 14.0604 4.3031 14.1327C4.33307 14.205 4.37702 14.2708 4.43244 14.3261C4.48785 14.3814 4.55365 14.4252 4.62604 14.4551C4.69843 14.4849 4.77601 14.5002 4.85431 14.5Z" fill="#103F91" />
                          <path opacity="0.1" d="M8.21881 4.09961H4.25781V12.2246H8.21881C8.37665 12.2238 8.52781 12.1609 8.63956 12.0494C8.75131 11.9379 8.81463 11.7869 8.81581 11.6291V4.69511C8.81463 4.53728 8.75131 4.38627 8.63956 4.2748C8.52781 4.16334 8.37665 4.10039 8.21881 4.09961Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V12.5498H7.89331C8.05115 12.549 8.20231 12.4861 8.31406 12.3746C8.42581 12.2631 8.48913 12.1121 8.49031 11.9543V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V11.8998H7.89331C8.05115 11.899 8.20231 11.8361 8.31406 11.7246C8.42581 11.6131 8.48913 11.4621 8.49031 11.3043V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.56781 4.4248H4.25781V11.8998H7.56781C7.72565 11.899 7.87681 11.8361 7.98856 11.7246C8.10031 11.6131 8.16363 11.4621 8.16481 11.3043V5.0203C8.16363 4.86247 8.10031 4.71147 7.98856 4.6C7.87681 4.48853 7.72565 4.42559 7.56781 4.4248Z" fill="black" />
                          <path d="M1.597 4.42481H7.566C7.72411 4.42468 7.87581 4.48732 7.98776 4.59899C8.0997 4.71065 8.16273 4.86219 8.163 5.02031V10.9793C8.16273 11.1374 8.0997 11.289 7.98776 11.4006C7.87581 11.5123 7.72411 11.5749 7.566 11.5748H1.597C1.51865 11.5751 1.44103 11.5599 1.36857 11.53C1.29612 11.5002 1.23027 11.4564 1.1748 11.4011C1.11933 11.3457 1.07534 11.28 1.04534 11.2076C1.01534 11.1352 0.999934 11.0577 1 10.9793V5.02031C0.999934 4.94196 1.01534 4.86437 1.04534 4.79199C1.07534 4.71962 1.11933 4.65388 1.1748 4.59855C1.23027 4.54322 1.29612 4.49939 1.36857 4.46957C1.44103 4.43976 1.51865 4.42454 1.597 4.42481Z" fill="url(#paint0_linear_3764_5530)" />
                          <path d="M3.44875 8.99357C3.46042 9.08557 3.46808 9.16574 3.47175 9.23407H3.48575C3.49075 9.16907 3.50158 9.09074 3.51825 8.99907C3.54325 8.86157 3.54925 8.83007 3.56275 8.76657L4.19025 6.06307H5.00225L5.65225 8.72607C5.68979 8.89086 5.71684 9.05786 5.73325 9.22607H5.74425C5.75672 9.06234 5.77927 8.89953 5.81175 8.73857L6.33125 6.05957H7.06975L6.15775 9.93357H5.29425L4.67575 7.37057C4.65775 7.29657 4.63742 7.20024 4.61475 7.08157C4.59208 6.9629 4.57808 6.87624 4.57275 6.82157H4.56225C4.55525 6.88457 4.54125 6.97807 4.52025 7.10207C4.49925 7.22607 4.48258 7.31807 4.47025 7.37807L3.88875 9.93507H3.01075L2.09375 6.06307H2.84375L3.40925 8.77207C3.42573 8.84527 3.43891 8.91918 3.44875 8.99357Z" fill="white" />
                          <defs>
                            <linearGradient id="paint0_linear_3764_5530" x1="2.247" y1="3.95681" x2="6.916" y2="12.0428" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#2368C4" />
                              <stop offset="0.5" stop-color="#1A5DBE" />
                              <stop offset="1" stop-color="#1146AC" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <span title="Export to PDF" onClick={() => dispatch(setExport('Print'))}>
                        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.3531 3.51094C11.4469 3.60469 11.5 3.73125 11.5 3.86406V13.5C11.5 13.7766 11.2766 14 11 14H1C0.723437 14 0.5 13.7766 0.5 13.5V0.5C0.5 0.223437 0.723437 0 1 0H7.63594C7.76875 0 7.89688 0.053125 7.99063 0.146875L11.3531 3.51094ZM10.3469 4.09375L7.40625 1.15313V4.09375H10.3469ZM7.89406 8.95719C7.65687 8.94938 7.40469 8.96766 7.11828 9.00344C6.73859 8.76922 6.48297 8.4475 6.30141 7.97484L6.31812 7.90641L6.3375 7.82547C6.40469 7.54219 6.44078 7.33547 6.45156 7.12703C6.45969 6.96969 6.45094 6.82453 6.42297 6.69C6.37141 6.39953 6.16594 6.22969 5.90703 6.21922C5.66562 6.20937 5.44375 6.34422 5.38703 6.55312C5.29469 6.89094 5.34875 7.33547 5.54453 8.09359C5.29516 8.68812 4.96562 9.38516 4.74453 9.77391C4.44937 9.92609 4.21953 10.0645 4.02641 10.218C3.77172 10.4206 3.61266 10.6289 3.56891 10.8477C3.54766 10.9491 3.57969 11.0816 3.65266 11.1902C3.73547 11.3133 3.86016 11.3933 4.00969 11.4048C4.38703 11.4341 4.85078 11.045 5.36281 10.1664C5.41422 10.1492 5.46859 10.1311 5.535 10.1086L5.72094 10.0458C5.83859 10.0061 5.92391 9.97766 6.00828 9.95031C6.37391 9.83125 6.65047 9.75609 6.90203 9.71328C7.33922 9.94734 7.84453 10.1008 8.18484 10.1008C8.46578 10.1008 8.65562 9.95516 8.72422 9.72594C8.78437 9.52469 8.73672 9.29125 8.60734 9.16219C8.47359 9.03078 8.22766 8.96797 7.89406 8.95719ZM4.01922 10.9637V10.9581L4.02125 10.9528C4.04413 10.8937 4.07347 10.8373 4.10875 10.7847C4.17562 10.6819 4.26766 10.5737 4.38172 10.4586C4.44297 10.3969 4.50672 10.3367 4.58156 10.2692C4.59828 10.2542 4.70516 10.1591 4.72516 10.1403L4.89969 9.97781L4.77281 10.1798C4.58031 10.4867 4.40625 10.7077 4.25719 10.8517C4.20234 10.9048 4.15406 10.9439 4.115 10.9691C4.10211 10.9777 4.08846 10.9851 4.07422 10.9913C4.06781 10.9939 4.06219 10.9955 4.05656 10.9959C4.05062 10.9967 4.04459 10.9959 4.03906 10.9936C4.03318 10.9911 4.02816 10.987 4.02463 10.9817C4.0211 10.9764 4.01922 10.9701 4.01922 10.9637ZM5.98703 7.55313L5.95172 7.61563L5.92984 7.54719C5.88141 7.39359 5.84578 7.16219 5.83594 6.95344C5.82469 6.71594 5.84359 6.57344 5.91859 6.57344C6.02391 6.57344 6.07219 6.74219 6.07594 6.99609C6.07937 7.21922 6.04422 7.45141 5.98688 7.55313H5.98703ZM5.89625 8.46656L5.92016 8.40328L5.95281 8.46266C6.13547 8.79453 6.3725 9.07141 6.63313 9.26437L6.68937 9.30594L6.62078 9.32C6.36562 9.37281 6.12797 9.45219 5.80297 9.58328C5.83688 9.56953 5.46516 9.72172 5.37109 9.75781L5.28906 9.78922L5.33281 9.71297C5.52578 9.37703 5.70406 8.97359 5.89609 8.46656H5.89625ZM8.35906 9.65812C8.23625 9.70656 7.97187 9.66328 7.50641 9.46453L7.38828 9.41422L7.51641 9.40484C7.88047 9.37781 8.13828 9.39781 8.28859 9.45281C8.35266 9.47625 8.39531 9.50578 8.41422 9.53953C8.42417 9.55551 8.42751 9.57473 8.42355 9.59313C8.41958 9.61153 8.40862 9.62766 8.39297 9.63813C8.38303 9.64688 8.37153 9.65366 8.35906 9.65812Z" fill="#F31D20" />
                        </svg>

                      </span>
                    </div>
                  )}

                  {Subtype !== 0 && Subtype !== null && LeftHeadMenu !== "Reports" && PageName !== "History" && (
                    <div className="leftmargin">
                      <span title="Export to Excel" onClick={() => dispatch(setExport('true'))}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.79231 7.6752L4.25781 6.7002V13.9047C4.25775 13.983 4.27314 14.0605 4.3031 14.1329C4.33307 14.2052 4.37702 14.271 4.43244 14.3263C4.48785 14.3816 4.55365 14.4254 4.62604 14.4553C4.69843 14.4851 4.77601 14.5004 4.85431 14.5002H14.4043C14.4827 14.5005 14.5604 14.4854 14.6329 14.4556C14.7054 14.4258 14.7713 14.382 14.8268 14.3266C14.8824 14.2713 14.9264 14.2055 14.9564 14.1331C14.9865 14.0607 15.0019 13.9831 15.0018 13.9047V11.2502L9.79231 7.6752Z" fill="#185C37" />
                          <path d="M9.79231 1.5H4.85431C4.77601 1.4998 4.69843 1.51507 4.62604 1.54491C4.55365 1.57475 4.48785 1.6186 4.43244 1.67392C4.37702 1.72924 4.33307 1.79496 4.3031 1.8673C4.27314 1.93965 4.25775 2.0172 4.25781 2.0955V4.75L9.79231 8L12.7228 8.975L15.0018 8V4.75L9.79231 1.5Z" fill="#21A366" />
                          <path d="M4.25781 4.75H9.79231V8H4.25781V4.75Z" fill="#107C41" />
                          <path opacity="0.1" d="M8.21881 4.09961H4.25781V12.2246H8.21881C8.37665 12.2238 8.52781 12.1609 8.63956 12.0494C8.75131 11.9379 8.81463 11.7869 8.81581 11.6291V4.69511C8.81463 4.53728 8.75131 4.38627 8.63956 4.2748C8.52781 4.16334 8.37665 4.10039 8.21881 4.09961Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V12.5498H7.89331C8.05115 12.549 8.20231 12.4861 8.31406 12.3746C8.42581 12.2631 8.48913 12.1121 8.49031 11.9543V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V11.8998H7.89331C8.05115 11.899 8.20231 11.8361 8.31406 11.7246C8.42581 11.6131 8.48913 11.4621 8.49031 11.3043V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.56781 4.4248H4.25781V11.8998H7.56781C7.72565 11.899 7.87681 11.8361 7.98856 11.7246C8.10031 11.6131 8.16363 11.4621 8.16481 11.3043V5.0203C8.16363 4.86247 8.10031 4.71147 7.98856 4.6C7.87681 4.48853 7.72565 4.42559 7.56781 4.4248Z" fill="black" />
                          <path d="M1.597 4.42481H7.566C7.72411 4.42468 7.87581 4.48732 7.98776 4.59899C8.0997 4.71065 8.16273 4.86219 8.163 5.02031V10.9793C8.16273 11.1374 8.0997 11.289 7.98776 11.4006C7.87581 11.5123 7.72411 11.5749 7.566 11.5748H1.597C1.51865 11.5751 1.44103 11.5599 1.36857 11.53C1.29612 11.5002 1.23027 11.4564 1.1748 11.4011C1.11933 11.3457 1.07534 11.28 1.04534 11.2076C1.01534 11.1352 0.999934 11.0577 1 10.9793V5.02031C0.999934 4.94196 1.01534 4.86437 1.04534 4.79199C1.07534 4.71962 1.11933 4.65388 1.1748 4.59855C1.23027 4.54322 1.29612 4.49939 1.36857 4.46957C1.44103 4.43976 1.51865 4.42454 1.597 4.42481Z" fill="url(#paint0_linear_3764_5518)" />
                          <path d="M2.85156 9.93648L4.10706 7.99448L2.95706 6.06348H3.88056L4.50806 7.29998C4.56606 7.41698 4.60806 7.50398 4.62706 7.56198H4.63556C4.67656 7.46831 4.7199 7.37731 4.76556 7.28898L5.43656 6.06548H6.28656L5.10706 7.98548L6.31656 9.93798H5.41206L4.68706 8.58248C4.6535 8.52415 4.62489 8.4631 4.60156 8.39998H4.58956C4.56837 8.4615 4.54019 8.52038 4.50556 8.57548L3.75906 9.93648H2.85156Z" fill="white" />
                          <path d="M14.4016 1.5H9.78906V4.75H14.9986V2.0955C14.9986 2.01716 14.9832 1.93957 14.9532 1.86719C14.9232 1.79481 14.8792 1.72907 14.8238 1.67374C14.7683 1.61841 14.7024 1.57458 14.63 1.54477C14.5575 1.51495 14.4799 1.49974 14.4016 1.5Z" fill="#33C481" />
                          <path d="M9.78906 8H14.9986V11.25H9.78906V8Z" fill="#107C41" />
                          <defs>
                            <linearGradient id="paint0_linear_3764_5518" x1="2.247" y1="3.95681" x2="6.916" y2="12.0428" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#18884F" />
                              <stop offset="0.5" stop-color="#117E43" />
                              <stop offset="1" stop-color="#0B6631" />
                            </linearGradient>
                          </defs>
                        </svg>

                      </span>
                    </div>
                  )}

                  {/* {(PageName === 'History') && (
                  <div className="common-select">
                    <select onChange={(e) => dispatch(setExport(e.target.value))} value={Export}>
                      <option value="false" selected disabled>Export</option>
                      <option value="Exportpdf">Export PDF</option>
                      <option value="Exportword">Export Word</option>
                      <option value="Print">Print</option>
                    </select>
                  </div>
                )} */}

                  {(Subtype !== 0 && Subtype !== null) && (PageName === 'History' || (PageName === 'Sector Trend' && Innerpage === true)) && (
                    <div className='ms-1'>
                      <span title="Export to Word" onClick={() => dispatch(setExport('Exportword'))} >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.4048 1.5H4.85431C4.77601 1.49981 4.69843 1.51507 4.62604 1.54491C4.55365 1.57476 4.48785 1.6186 4.43244 1.67392C4.37702 1.72924 4.33307 1.79496 4.3031 1.86731C4.27314 1.93965 4.25775 2.0172 4.25781 2.0955V4.75L9.79231 6.375L15.0018 4.75V2.0955C15.0019 2.01716 14.9865 1.93957 14.9565 1.86719C14.9265 1.79481 14.8825 1.72907 14.827 1.67374C14.7715 1.61841 14.7057 1.57458 14.6332 1.54477C14.5608 1.51495 14.4832 1.49974 14.4048 1.5Z" fill="#41A5EE" />
                          <path d="M15.0018 4.75H4.25781V8L9.79231 8.975L15.0018 8V4.75Z" fill="#2B7CD3" />
                          <path d="M4.25781 8V11.25L9.46681 11.9L15.0018 11.25V8H4.25781Z" fill="#185ABD" />
                          <path d="M4.85431 14.5H14.4043C14.4827 14.5003 14.5604 14.4852 14.6329 14.4554C14.7054 14.4256 14.7713 14.3818 14.8268 14.3264C14.8824 14.2711 14.9264 14.2053 14.9564 14.1329C14.9865 14.0605 15.0019 13.9829 15.0018 13.9045V11.25H4.25781V13.9045C4.25775 13.9828 4.27314 14.0604 4.3031 14.1327C4.33307 14.205 4.37702 14.2708 4.43244 14.3261C4.48785 14.3814 4.55365 14.4252 4.62604 14.4551C4.69843 14.4849 4.77601 14.5002 4.85431 14.5Z" fill="#103F91" />
                          <path opacity="0.1" d="M8.21881 4.09961H4.25781V12.2246H8.21881C8.37665 12.2238 8.52781 12.1609 8.63956 12.0494C8.75131 11.9379 8.81463 11.7869 8.81581 11.6291V4.69511C8.81463 4.53728 8.75131 4.38627 8.63956 4.2748C8.52781 4.16334 8.37665 4.10039 8.21881 4.09961Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V12.5498H7.89331C8.05115 12.549 8.20231 12.4861 8.31406 12.3746C8.42581 12.2631 8.48913 12.1121 8.49031 11.9543V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.89331 4.4248H4.25781V11.8998H7.89331C8.05115 11.899 8.20231 11.8361 8.31406 11.7246C8.42581 11.6131 8.48913 11.4621 8.49031 11.3043V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                          <path opacity="0.2" d="M7.56781 4.4248H4.25781V11.8998H7.56781C7.72565 11.899 7.87681 11.8361 7.98856 11.7246C8.10031 11.6131 8.16363 11.4621 8.16481 11.3043V5.0203C8.16363 4.86247 8.10031 4.71147 7.98856 4.6C7.87681 4.48853 7.72565 4.42559 7.56781 4.4248Z" fill="black" />
                          <path d="M1.597 4.42481H7.566C7.72411 4.42468 7.87581 4.48732 7.98776 4.59899C8.0997 4.71065 8.16273 4.86219 8.163 5.02031V10.9793C8.16273 11.1374 8.0997 11.289 7.98776 11.4006C7.87581 11.5123 7.72411 11.5749 7.566 11.5748H1.597C1.51865 11.5751 1.44103 11.5599 1.36857 11.53C1.29612 11.5002 1.23027 11.4564 1.1748 11.4011C1.11933 11.3457 1.07534 11.28 1.04534 11.2076C1.01534 11.1352 0.999934 11.0577 1 10.9793V5.02031C0.999934 4.94196 1.01534 4.86437 1.04534 4.79199C1.07534 4.71962 1.11933 4.65388 1.1748 4.59855C1.23027 4.54322 1.29612 4.49939 1.36857 4.46957C1.44103 4.43976 1.51865 4.42454 1.597 4.42481Z" fill="url(#paint0_linear_3764_5530)" />
                          <path d="M3.44875 8.99357C3.46042 9.08557 3.46808 9.16574 3.47175 9.23407H3.48575C3.49075 9.16907 3.50158 9.09074 3.51825 8.99907C3.54325 8.86157 3.54925 8.83007 3.56275 8.76657L4.19025 6.06307H5.00225L5.65225 8.72607C5.68979 8.89086 5.71684 9.05786 5.73325 9.22607H5.74425C5.75672 9.06234 5.77927 8.89953 5.81175 8.73857L6.33125 6.05957H7.06975L6.15775 9.93357H5.29425L4.67575 7.37057C4.65775 7.29657 4.63742 7.20024 4.61475 7.08157C4.59208 6.9629 4.57808 6.87624 4.57275 6.82157H4.56225C4.55525 6.88457 4.54125 6.97807 4.52025 7.10207C4.49925 7.22607 4.48258 7.31807 4.47025 7.37807L3.88875 9.93507H3.01075L2.09375 6.06307H2.84375L3.40925 8.77207C3.42573 8.84527 3.43891 8.91918 3.44875 8.99357Z" fill="white" />
                          <defs>
                            <linearGradient id="paint0_linear_3764_5530" x1="2.247" y1="3.95681" x2="6.916" y2="12.0428" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#2368C4" />
                              <stop offset="0.5" stop-color="#1A5DBE" />
                              <stop offset="1" stop-color="#1146AC" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <span title="Export to PDF" onClick={() => dispatch(setExport('Print'))}>
                        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.3531 3.51094C11.4469 3.60469 11.5 3.73125 11.5 3.86406V13.5C11.5 13.7766 11.2766 14 11 14H1C0.723437 14 0.5 13.7766 0.5 13.5V0.5C0.5 0.223437 0.723437 0 1 0H7.63594C7.76875 0 7.89688 0.053125 7.99063 0.146875L11.3531 3.51094ZM10.3469 4.09375L7.40625 1.15313V4.09375H10.3469ZM7.89406 8.95719C7.65687 8.94938 7.40469 8.96766 7.11828 9.00344C6.73859 8.76922 6.48297 8.4475 6.30141 7.97484L6.31812 7.90641L6.3375 7.82547C6.40469 7.54219 6.44078 7.33547 6.45156 7.12703C6.45969 6.96969 6.45094 6.82453 6.42297 6.69C6.37141 6.39953 6.16594 6.22969 5.90703 6.21922C5.66562 6.20937 5.44375 6.34422 5.38703 6.55312C5.29469 6.89094 5.34875 7.33547 5.54453 8.09359C5.29516 8.68812 4.96562 9.38516 4.74453 9.77391C4.44937 9.92609 4.21953 10.0645 4.02641 10.218C3.77172 10.4206 3.61266 10.6289 3.56891 10.8477C3.54766 10.9491 3.57969 11.0816 3.65266 11.1902C3.73547 11.3133 3.86016 11.3933 4.00969 11.4048C4.38703 11.4341 4.85078 11.045 5.36281 10.1664C5.41422 10.1492 5.46859 10.1311 5.535 10.1086L5.72094 10.0458C5.83859 10.0061 5.92391 9.97766 6.00828 9.95031C6.37391 9.83125 6.65047 9.75609 6.90203 9.71328C7.33922 9.94734 7.84453 10.1008 8.18484 10.1008C8.46578 10.1008 8.65562 9.95516 8.72422 9.72594C8.78437 9.52469 8.73672 9.29125 8.60734 9.16219C8.47359 9.03078 8.22766 8.96797 7.89406 8.95719ZM4.01922 10.9637V10.9581L4.02125 10.9528C4.04413 10.8937 4.07347 10.8373 4.10875 10.7847C4.17562 10.6819 4.26766 10.5737 4.38172 10.4586C4.44297 10.3969 4.50672 10.3367 4.58156 10.2692C4.59828 10.2542 4.70516 10.1591 4.72516 10.1403L4.89969 9.97781L4.77281 10.1798C4.58031 10.4867 4.40625 10.7077 4.25719 10.8517C4.20234 10.9048 4.15406 10.9439 4.115 10.9691C4.10211 10.9777 4.08846 10.9851 4.07422 10.9913C4.06781 10.9939 4.06219 10.9955 4.05656 10.9959C4.05062 10.9967 4.04459 10.9959 4.03906 10.9936C4.03318 10.9911 4.02816 10.987 4.02463 10.9817C4.0211 10.9764 4.01922 10.9701 4.01922 10.9637ZM5.98703 7.55313L5.95172 7.61563L5.92984 7.54719C5.88141 7.39359 5.84578 7.16219 5.83594 6.95344C5.82469 6.71594 5.84359 6.57344 5.91859 6.57344C6.02391 6.57344 6.07219 6.74219 6.07594 6.99609C6.07937 7.21922 6.04422 7.45141 5.98688 7.55313H5.98703ZM5.89625 8.46656L5.92016 8.40328L5.95281 8.46266C6.13547 8.79453 6.3725 9.07141 6.63313 9.26437L6.68937 9.30594L6.62078 9.32C6.36562 9.37281 6.12797 9.45219 5.80297 9.58328C5.83688 9.56953 5.46516 9.72172 5.37109 9.75781L5.28906 9.78922L5.33281 9.71297C5.52578 9.37703 5.70406 8.97359 5.89609 8.46656H5.89625ZM8.35906 9.65812C8.23625 9.70656 7.97187 9.66328 7.50641 9.46453L7.38828 9.41422L7.51641 9.40484C7.88047 9.37781 8.13828 9.39781 8.28859 9.45281C8.35266 9.47625 8.39531 9.50578 8.41422 9.53953C8.42417 9.55551 8.42751 9.57473 8.42355 9.59313C8.41958 9.61153 8.40862 9.62766 8.39297 9.63813C8.38303 9.64688 8.37153 9.65366 8.35906 9.65812Z" fill="#F31D20" />
                        </svg>

                      </span>
                    </div>
                  )}
                  {GetReportAnalysis !== 0 && GetReportAnalysis !== null && (SelectedCompany[0]?.Co_Code || SelectedCompany[0]?.co_code) && (
                    <span onClick={() => handleSubmitLive()} title="Generate Report Analysis">
                      <svg width="16" height="16" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 7H14.5L9 1.5V7ZM2 0H10L16 6V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V2C0 0.89 0.89 0 2 0ZM3 18H5V12H3V18ZM7 18H9V10H7V18ZM11 18H13V14H11V18Z" fill="#F01D16" />
                      </svg>
                    </span>
                    // <img src={ReportAnalysis} sizes={16} ></img>
                  )}


                </div>
              </div>
              {(TopNavigateTap[1] == "Company" || TopNavigateTap[1] == "CS") && SelectedLeftTab == "" && SelectedCompany != "" && (
                <div className="bottom">
                  <ul className="horizon_dotted-points">
                    <li>
                      BSE -{" "}
                      {SelectedCompany[0]?.SC_Code != null
                        ? SelectedCompany[0]?.SC_Code
                        : "NA"}
                    </li>
                    <li>
                      NSE-{" "}
                      {SelectedCompany[0]?.SYMBOL != null
                        ? SelectedCompany[0]?.SYMBOL
                        : "NA"}
                    </li>
                    <li>
                      ISIN -{" "}
                      {SelectedCompany[0]?.ISIN != null
                        ? SelectedCompany[0]?.ISIN
                        : "NA"}
                    </li>
                    <li title={SelectedCompany[0]?.Sector.length > 20 ? SelectedCompany[0]?.Sector : ''}>
                      Sector -{" "}
                      {SelectedCompany[0]?.Sector != null
                        ? `${SelectedCompany[0]?.Sector.slice(0, 20)}${SelectedCompany[0]?.Sector.length > 20 ? '...' : ''}`
                        : "NA"}
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="right">

            <div className="common-input searchbar">
              {showTypeahead && (
                <Typeahead
                  className={`${ErrorStatus ? "error" : ""}`}
                  id="companySearch"
                  labelKey={(option) => `${option.Name || option.CO_NAME || option.CO_CODE}`}
                  minLength={2}
                  options={Companies}
                  style={{ color: "red" }}
                  placeholder={getPlaceholder()}
                  onChange={selectedCompanyFunc}
                  value={searchText}
                  onInputChange={(query) => {
                    setSearchText(query);
                    GetSearchCompanies(query);
                  }}
                  selected={selected}
                  inputValue={searchText}
                  filterBy={() => true}
                  renderMenuItemChildren={(option, props) => {
                    const label = `${option.Name || option.CO_NAME || option.CO_CODE}`;
                    const query = props.text; // This is the current input

                    const regex = new RegExp(`(${query})`, 'gi');
                    const parts = label.split(regex);

                    return (
                      <div>
                        {parts.map((part, index) =>
                          regex.test(part) ? (
                            <strong key={index}>{part}</strong> // Bold match
                          ) : (
                            <span key={index}>{part}</span> // Normal text
                          )
                        )}
                      </div>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {
        TopNavigateTap[1] == "Peerset" && (
          <>
            <div className={`main-company-box ${scrolled ? "scrolled-class" : ""}`} >
              {/* style={{ width: `calc(100vw - ${width}px - ${30}px)` }} */}
              <div className="left">
                <div className="company-detail">
                  <p className={SelectedPeerset == "" ? 'redcolor' : ''}>
                    {SelectedPeerset == ""
                      ? "Please select Peerset from dropdown"
                      : SelectedPeerset}
                  </p>
                  <p></p>
                </div>
              </div>
              <div className="d-flex">
                {Subtype !== 0 && Subtype !== null && (
                  <div className="mar4px me-2">
                    <span title="Export to Excel" onClick={() => dispatch(setExport('true'))}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.79231 7.6752L4.25781 6.7002V13.9047C4.25775 13.983 4.27314 14.0605 4.3031 14.1329C4.33307 14.2052 4.37702 14.271 4.43244 14.3263C4.48785 14.3816 4.55365 14.4254 4.62604 14.4553C4.69843 14.4851 4.77601 14.5004 4.85431 14.5002H14.4043C14.4827 14.5005 14.5604 14.4854 14.6329 14.4556C14.7054 14.4258 14.7713 14.382 14.8268 14.3266C14.8824 14.2713 14.9264 14.2055 14.9564 14.1331C14.9865 14.0607 15.0019 13.9831 15.0018 13.9047V11.2502L9.79231 7.6752Z" fill="#185C37" />
                        <path d="M9.79231 1.5H4.85431C4.77601 1.4998 4.69843 1.51507 4.62604 1.54491C4.55365 1.57475 4.48785 1.6186 4.43244 1.67392C4.37702 1.72924 4.33307 1.79496 4.3031 1.8673C4.27314 1.93965 4.25775 2.0172 4.25781 2.0955V4.75L9.79231 8L12.7228 8.975L15.0018 8V4.75L9.79231 1.5Z" fill="#21A366" />
                        <path d="M4.25781 4.75H9.79231V8H4.25781V4.75Z" fill="#107C41" />
                        <path opacity="0.1" d="M8.21881 4.09961H4.25781V12.2246H8.21881C8.37665 12.2238 8.52781 12.1609 8.63956 12.0494C8.75131 11.9379 8.81463 11.7869 8.81581 11.6291V4.69511C8.81463 4.53728 8.75131 4.38627 8.63956 4.2748C8.52781 4.16334 8.37665 4.10039 8.21881 4.09961Z" fill="black" />
                        <path opacity="0.2" d="M7.89331 4.4248H4.25781V12.5498H7.89331C8.05115 12.549 8.20231 12.4861 8.31406 12.3746C8.42581 12.2631 8.48913 12.1121 8.49031 11.9543V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                        <path opacity="0.2" d="M7.89331 4.4248H4.25781V11.8998H7.89331C8.05115 11.899 8.20231 11.8361 8.31406 11.7246C8.42581 11.6131 8.48913 11.4621 8.49031 11.3043V5.0203C8.48913 4.86247 8.42581 4.71147 8.31406 4.6C8.20231 4.48853 8.05115 4.42559 7.89331 4.4248Z" fill="black" />
                        <path opacity="0.2" d="M7.56781 4.4248H4.25781V11.8998H7.56781C7.72565 11.899 7.87681 11.8361 7.98856 11.7246C8.10031 11.6131 8.16363 11.4621 8.16481 11.3043V5.0203C8.16363 4.86247 8.10031 4.71147 7.98856 4.6C7.87681 4.48853 7.72565 4.42559 7.56781 4.4248Z" fill="black" />
                        <path d="M1.597 4.42481H7.566C7.72411 4.42468 7.87581 4.48732 7.98776 4.59899C8.0997 4.71065 8.16273 4.86219 8.163 5.02031V10.9793C8.16273 11.1374 8.0997 11.289 7.98776 11.4006C7.87581 11.5123 7.72411 11.5749 7.566 11.5748H1.597C1.51865 11.5751 1.44103 11.5599 1.36857 11.53C1.29612 11.5002 1.23027 11.4564 1.1748 11.4011C1.11933 11.3457 1.07534 11.28 1.04534 11.2076C1.01534 11.1352 0.999934 11.0577 1 10.9793V5.02031C0.999934 4.94196 1.01534 4.86437 1.04534 4.79199C1.07534 4.71962 1.11933 4.65388 1.1748 4.59855C1.23027 4.54322 1.29612 4.49939 1.36857 4.46957C1.44103 4.43976 1.51865 4.42454 1.597 4.42481Z" fill="url(#paint0_linear_3764_5518)" />
                        <path d="M2.85156 9.93648L4.10706 7.99448L2.95706 6.06348H3.88056L4.50806 7.29998C4.56606 7.41698 4.60806 7.50398 4.62706 7.56198H4.63556C4.67656 7.46831 4.7199 7.37731 4.76556 7.28898L5.43656 6.06548H6.28656L5.10706 7.98548L6.31656 9.93798H5.41206L4.68706 8.58248C4.6535 8.52415 4.62489 8.4631 4.60156 8.39998H4.58956C4.56837 8.4615 4.54019 8.52038 4.50556 8.57548L3.75906 9.93648H2.85156Z" fill="white" />
                        <path d="M14.4016 1.5H9.78906V4.75H14.9986V2.0955C14.9986 2.01716 14.9832 1.93957 14.9532 1.86719C14.9232 1.79481 14.8792 1.72907 14.8238 1.67374C14.7683 1.61841 14.7024 1.57458 14.63 1.54477C14.5575 1.51495 14.4799 1.49974 14.4016 1.5Z" fill="#33C481" />
                        <path d="M9.78906 8H14.9986V11.25H9.78906V8Z" fill="#107C41" />
                        <defs>
                          <linearGradient id="paint0_linear_3764_5518" x1="2.247" y1="3.95681" x2="6.916" y2="12.0428" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#18884F" />
                            <stop offset="0.5" stop-color="#117E43" />
                            <stop offset="1" stop-color="#0B6631" />
                          </linearGradient>
                        </defs>
                      </svg>

                    </span>
                  </div>
                )}
                {/* <div class="common-select">
                  <select
                    onChange={(e) => {
                      dispatch(setPeersetName(e.target.value));
                      if (SelectedLeftTab === 'PeersetFact Sheet') {
                        navigate(`/Peerset/Peerset/PeersetFactSheet`)
                      }
                    }}
                  >
                    <option value={""} selected>
                      Select Peerset
                    </option>
                    {Peerset &&
                      Peerset.map((Item) => (
                        <option value={Item.Name}>{Item.Name}</option>
                      ))}
                  </select>
                </div> */}
                <div class="common-dropdown-container">
                  <div className="common-select">
                    <select onChange={(event) => {
                      setGetPeerSet(event.target.value);
                      if (event.target.value === "Common") {
                        dispatch(setPeersetType("COM"))
                      } else {
                        dispatch(setPeersetType(event.target.value))
                      }
                      localStorage.setItem("peersetType", event.target.value);
                      localStorage.setItem("peersetName", "select");
                    }}
                      value={getPeerSet}>
                      <option value="My">User Peerset</option>
                      <option value="CM">CM Peerset</option>
                      <option value="Common">Common Peerset</option>
                    </select>
                  </div>

                  {getPeerSet === "My" && (
                    <div className="common-select">
                      <select onChange={handleDropdownChange} value={peerSetValue} className='widthalign'>
                        <option value="select" disabled={peerSetValue !== "select"}>
                          Select User PeerSet
                        </option>
                        {Peerset.map((peerSet) => (
                          <option
                            key={peerSet.PeerSetName}
                            // value={`${peerSet.PeerSetValue}^${peerSet.PeerSetName}`}
                            value={peerSet.PeerSetName}
                          >
                            {peerSet.PeerSetName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {getPeerSet === "CM" && (
                    <div className="common-select">
                      <select>
                        <option value="">Select CM PeerSet</option>
                        {/* Populate CM PeerSet options here */}
                      </select>
                    </div>
                  )}
                  {getPeerSet === "Common" && (
                    <div className="common-select">
                      <select onChange={handleDropdownChange} value={peerSetValue}>
                        {/* <option value="">Select Common PeerSet</option> */}
                        <option
                          value="select"
                          disabled={peerSetValue !== "select"}
                          selected
                        >
                          Select Common PeerSet
                        </option>
                        {Peerset.map((peerSet) => (
                          <option
                            key={peerSet.PeerSetValue}
                            // value={`${peerSet.PeerSetValue}^${peerSet.PeerSetName}`}
                            value={peerSet.PeerSetName}
                          >
                            {peerSet.PeerSetName}
                          </option>
                        ))}
                      </select>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )
      }
    </>
  );
};
